import React from "react"

import {
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { StyledToggler, StyledSliderDiv } from './common-shape-form';
import { Slider } from "@mui/material";
import { NumericInput } from "./fields";
import TransparentColor from "./transparent-color";

const { min, max, abs, sin, cos, PI, round, atan2, sqrt, ceil } = Math

const ShadowForm = ({ formName, shape, activeShapeId, change }) => {
    const isShadow = shape.shadow_color && shape.shadow_sigma
    const subFormName = `shapes.${activeShapeId}`

    return (
        <React.Fragment>
            <GridCell>{trans('drop_shadow')}</GridCell>
            <GridCell style={{ textAlign: 'right', alignSelf: 'center' }}>
                <StyledToggler
                    value={!!isShadow}
                    onChange={(e: any) => {
                        if (e) {
                            const newShape = {
                                ...shape,
                                shadow_color: '#3a3a3a',
                                shadow_sigma: 5,
                                shadow_xoffset: 10,
                                shadow_yoffset: 10,
                                shadow_opacity: 40,
                            }
                            change(formName, `shapes.${activeShapeId}`, newShape)
                        } else {
                            const newShape = {
                                ...shape,
                                shadow_color: null,
                                shadow_sigma: null,
                                shadow_xoffset: null,
                                shadow_yoffset: null,
                                shadow_opacity: 100,
                            }
                            change(formName, `shapes.${activeShapeId}`, newShape)
                        }
                    }}
                />
            </GridCell>


            {isShadow ?
                <React.Fragment>
                    <GridCell>{trans('shadow_color')}</GridCell>
                    <GridCell>
                        <TransparentColor
                            name={`${formName}.${subFormName}.shadow_color`}
                            value={shape['shadow_color'] || '#3a3a3a'}
                            changeValue={(color: any) => {
                                change(formName, `${subFormName}.shadow_color`, color)
                            }}
                        />
                    </GridCell>
                    <GridCell>{trans('shadow_opacity')} [%]</GridCell>
                    <GridCell style={{ position: 'relative' }}>
                        <StyledSliderDiv>
                            <Slider
                                value={round(shape.shadow_opacity || 100)}
                                onChange={(event: Event, value: number) => change(formName, `shapes.${shape.index}.shadow_opacity`, value)}
                                step={1}
                                min={1}
                                max={100}
                                valueLabelDisplay="on"
                                getAriaLabel={() => trans('shadow_opacity')}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>
                    <GridCell>{trans('shadow_sigma')}</GridCell>
                    <GridCell style={{ position: 'relative' }}>
                        <StyledSliderDiv>
                            <Slider
                                value={round(shape.shadow_sigma || 2)}
                                onChange={(event: Event, value: number) => change(formName, `shapes.${shape.index}.shadow_sigma`, value)}
                                step={1}
                                min={2}
                                max={100}
                                valueLabelDisplay="on"
                                getAriaLabel={() => trans('shadow_sigma')}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>
                    <GridCell>{trans('angle')}</GridCell>
                    <GridCell>
                        <StyledSliderDiv>
                            <Slider
                                value={round(atan2(shape.shadow_yoffset, shape.shadow_xoffset) * 180 / PI + 360) % 360}
                                onChange={(event: Event, value: number) => {
                                    const R = round(sqrt(shape.shadow_yoffset ** 2 + shape.shadow_xoffset ** 2))
                                    const alpha = value / 180 * PI
                                    change(formName, `shapes.${shape.index}`, {
                                        ...shape,
                                        shadow_xoffset: R * cos(alpha),
                                        shadow_yoffset: R * sin(alpha),
                                    })
                                }}
                                min={0}
                                max={360}
                                step={10}
                                valueLabelDisplay="on"
                                getAriaLabel={() => trans('angle')}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>
                    <GridCell>{trans('shadow_offset')}</GridCell>
                    <GridCell style={{ position: 'relative' }}>
                        <Grid cols={'repeat(2, 1fr)'}>
                            <GridCell>
                                <NumericInput
                                    formName={formName}
                                    fieldName={'shadow_xoffset'}
                                    placeholder={'shadow_xoffset'}
                                    shapeIndex={shape.index}
                                    id={'shadow-xoffset-input'}
                                    step={5}
                                    units={'px'}
                                    value={round(shape.shadow_xoffset)}
                                />
                            </GridCell>
                            <GridCell>
                                <NumericInput
                                    formName={formName}
                                    fieldName={'shadow_yoffset'}
                                    placeholder={'shadow_yoffset'}
                                    shapeIndex={shape.index}
                                    id={'shadow-yoffset-input'}
                                    step={5}
                                    units={'px'}
                                    value={round(shape.shadow_yoffset)}
                                />
                            </GridCell>
                        </Grid>
                    </GridCell>
                </React.Fragment> :
                <GridCell col={'1/-1'} />
            }
        </React.Fragment>
    )
}

export default ShadowForm